<template>
  <div class="header_col">
    <div class="hco_col">
      <div class="header-l"><a href="/" class="logo-lw w-inline-block"><img
          src="https://cdn.prod.website-files.com/5e975a649e6ac66451307402/66a8fd03578b1593429dac04_ti_logo.svg"
          loading="lazy" alt="" class="logo"></a></div>
      <div class="header-r">
        <div class="header-i">
          <div class="tp_trv"><img
              src="https://cdn.prod.website-files.com/5e975a649e6ac66451307402/67d27072bacc6b2de894bf10_ecross.png"
              loading="lazy" alt="" class="image">
            <div>
              <div class="text-block">asistenčná služba<br>+ 420 296 339 631</div>
              <div class="rws">
                <div class="ico mr"></div>
                <div><a href="mailto:sisa@travelinsurance.sk" class="contact-link">sisa@travelinsurance.sk</a><br></div>
              </div>
              <div class="rws">
                <div class="ico mr"></div>
                <div><a href="tel:0907804872" class="contact-link">0907 804 872</a><br></div>
              </div>
            </div>
          </div>
        </div>
        <a href="#" class="ham w-inline-block">
          <div class="hm hm1"></div>
          <div class="hm hm2"></div>
          <div class="hm hm3"></div>
        </a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPart",
  props: {
    product: String
  }

}
</script>

<style scoped>
/*header{*/
/*  position: absolute;*/
/*  padding: 20px;*/
/*  z-index: 20;*/
/*  left: 20PX;*/
/*  right: 20PX;*/
/*  box-sizing: border-box;*/
/*}*/
/*  .header-co {*/
/*    width: 100%;*/
/*    border-bottom: 1px solid #00b14e;*/
/*    justify-content: space-between;*/
/*    align-items: center;*/
/*    margin-left: auto;*/
/*    margin-right: auto;*/
/*    padding: 20px 4px;*/
/*    display: flex;*/
/*    position: relative;*/
/*    color: white;*/
/*  }*/
/*  .logo{*/
/*    width: 140px;*/
/*  }*/

/*  h1 a{*/
/*    text-decoration: none;*/
/*  }*/

/*  a{*/
/*    text-decoration: none;*/
/*    color: white;*/
/*  }*/

.contact-link {
  color: inherit;
  text-decoration: none;
  font: inherit;
}
</style>